import React from 'react';
import { ExternalLink } from 'lucide-react';
import {
  generationErrorSourcePath,
  generationErrorSourceUrl,
  resolveGenerationErrorSource,
} from '../../lib/generationErrorSource';

interface Props {
  error: string | null | undefined;
  className?: string;
}

/** Link generation failures to the repo source that threw or handles the error. */
export const GenerationErrorSourceLink: React.FC<Props> = ({ error, className }) => {
  const source = resolveGenerationErrorSource(error);
  if (!source) return null;

  const path = generationErrorSourcePath(source);
  const url = generationErrorSourceUrl(source);

  return (
    <div className={className ?? 'space-y-1 pt-1 border-t border-danger/20'}>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1.5 type-meta text-danger/90 hover:text-danger underline underline-offset-2"
        data-testid="generation-error-source-link"
      >
        <ExternalLink className="w-3 h-3 shrink-0" />
        <span>
          Source: <code className="font-mono text-[10px]">{path}</code>
          {' · '}
          {source.label}
        </span>
      </a>
      {source.hint && (
        <p className="type-meta text-text-secondary leading-relaxed">{source.hint}</p>
      )}
    </div>
  );
};
